export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fecf8f37174dde11b4536f924209cad7f6faf53bd&name=fetchTypeahead!'